export default "__VITE_ASSET__DTj97GDp__"